import { APOSTA_ADDED, APOSTA_REMOVED, REQUEST_APOSTA_CARRINHO, RECEIVE_APOSTA_CARRINHO, RECEIVE_ETICKET, ERROR_ETICKET, ETICKET_REMOVED } from "./carrinhoActions";

const INITIAL_STATE = { 
    arrApostas: [],
    isFetching: false,
    eTickets: [] 
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type){
        case APOSTA_ADDED:
            return {
                ...state,
                arrApostas: action.payload
            }
        case APOSTA_REMOVED:{
            const index = state.arrApostas.findIndex( item => item.Aposta_ID === action.payload )

            const arr = state.arrApostas
            arr.splice(index, 1)
            return {
                ...state,
                arrApostas: arr
            }
        }
        case REQUEST_APOSTA_CARRINHO:
            return {
                ...state,
                isFetching: true
            };
  
        case RECEIVE_APOSTA_CARRINHO:
            return {
                ...state,
                isFetching: false
            };

        case RECEIVE_ETICKET:
            return {
                ...state,
                eTickets: action.payload,
                ticketError:false,
                arrApostas:[]
            }
        case ERROR_ETICKET:
            return{
                ...state,
                ticketError:true,
            }
        case ETICKET_REMOVED:{
                const index = state.eTickets.findIndex( item => item.vchETicket === action.payload )
    
                const arr = state.eTickets
                arr.splice(index, 1)
                return {
                    ...state,
                    eTickets: arr
                }
            }
                                         
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/carrinho/carrinhoReducer.js